"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageOperatorReviewStatusSchema = exports.PackageOperatorReviewStatus = void 0;
const z = require("zod");
var PackageOperatorReviewStatus;
(function (PackageOperatorReviewStatus) {
    PackageOperatorReviewStatus["Published"] = "published";
    PackageOperatorReviewStatus["OperatorReviewComplete"] = "operatorReviewComplete";
    PackageOperatorReviewStatus["AwaitingOperatorReview"] = "awaitingOperatorReview";
    PackageOperatorReviewStatus["OperatorReviewFailed"] = "operatorReviewFailed";
    PackageOperatorReviewStatus["OperatorReviewCancelled"] = "operatorReviewCancelled";
    PackageOperatorReviewStatus["NotSubmittedForOperatorReview"] = "notSubmittedForOperatorReview";
})(PackageOperatorReviewStatus || (exports.PackageOperatorReviewStatus = PackageOperatorReviewStatus = {}));
exports.packageOperatorReviewStatusSchema = z.nativeEnum(PackageOperatorReviewStatus);
//# sourceMappingURL=package-operator-review-status.js.map